import { BASKET_PROMOTION_ITEM_DATA } from "theme/config/constants";
import Cookies from "js-cookie";
import buildCartProductTree from "core-web/utils/buildCartProductTree";
import { getAddressFromCheckout } from "core-web/state/models/Basket/utils/getAddressFromCheckout";
import getBasketInfoFieldByCode from "core-web/state/models/Basket/utils/getBasketInfoFieldByCode";
import setBasketItemsAmountCookie from "core-web/state/models/Basket/utils/setBasketItemsAmountCookie";
import setUniqueBasketItemsAmountCookie from "core-web/state/models/Basket/utils/setUniqueBasketItemsAmountCookie";

const buildCheckoutResponse = (response) => {
    const {
        basket,
        ingrid,
        payments,
        ship_to: shipToAddress,
        payment_methods: paymentMethods,
        virtual_basket: isVirtualBasket,
    } = response.data;
    const address = getAddressFromCheckout(shipToAddress);
    const basketItemsTree = buildCartProductTree(basket.items);
    const basketItemsCount = basketItemsTree.reduce((total, item) => total + (item.quantity || 0), 0);
    setBasketItemsAmountCookie(basketItemsCount);
    setUniqueBasketItemsAmountCookie(basketItemsTree.length);
    Cookies.set("basket_items_amount", basketItemsCount);
    Cookies.set("basket_unique_items_amount", basketItemsTree.length);

    const basketPromotionItemData = JSON.parse(
        getBasketInfoFieldByCode(BASKET_PROMOTION_ITEM_DATA, basket.info)?.value || "{}",
    );
    const activeMemberPromotions = Object.keys(basketPromotionItemData).reduce((promotions, partNo) => {
        const currentProductPromotions = basketPromotionItemData?.[partNo];

        if (!currentProductPromotions) {
            return promotions;
        }

        currentProductPromotions.forEach((appliedPromotion) => {
            const { id, discount_amount: discountAmount } = appliedPromotion;

            if (id === null) {
                return promotions;
            }

            if (promotions.some((promotion) => promotion.id === id)) {
                promotions = promotions.map((promotion) => {
                    if (promotion.id === id) {
                        return Object.assign(promotion, {
                            discountAmount: promotion.discountAmount + discountAmount,
                        });
                    }

                    return promotion;
                });
            } else {
                promotions.push({ id, discountAmount });
            }
        });

        return promotions;
    }, []);

    const memberPromotionDiscountAmount = activeMemberPromotions.reduce(
        (discount, { discountAmount: promotionDiscountAmount }) => (discount += promotionDiscountAmount || 0),
        0,
    );

    const ingridData = {
        iframe: ingrid?.iframe,
        postalCode: ingrid?.session?.search_address?.postal_code,
    };

    return {
        checkoutResponse: {
            items: basketItemsTree,
            currency: basket.currency_id || null,
            summary: basket.format.summary || [],
            comment: basket.comment,
            textComments: basket.format.text_comment || [],
            paymentMethods,
            promotions: basket.applied_promotions,
            info: basket.info || [],
            payments,
            ingrid: ingridData,
            address,
            isVirtualBasket,
            activeMemberPromotions,
            memberPromotionDiscountAmount,
        },
        basketItemsTree,
    };
};

export default buildCheckoutResponse;
